import { ReactNode } from 'react';
import { Box, ColumnLayout, Container, Header, SpaceBetween } from '@amzn/awsui-components-react';
import './activitySummary.scss';

export interface ActivitySummaryPanelProps {
  header: string;
  leadSentence?: string;
  // Only the tiles that should show. Hidden and failed tiles are left out by the caller. Lays out
  // at most 4 columns, so a fifth tile wraps onto a second row.
  tiles: ReactNode[];
}

/**
 * Shared shell for the Volunteer and Coordinator summaries (cce-4530, cce-8083): a header, an
 * optional lead sentence, and a row of tiles with column dividers. Renders nothing when no tile is
 * left, which covers the "every tile failed" state.
 */
export function ActivitySummaryPanel({ header, leadSentence, tiles }: ActivitySummaryPanelProps) {
  if (tiles.length === 0) return null;

  return (
    <Container header={<Header variant="h2">{header}</Header>}>
      <SpaceBetween size="m">
        {leadSentence && <Box fontSize="heading-l">{leadSentence}</Box>}
        <div className="activity-summary-tiles">
          <ColumnLayout columns={Math.min(tiles.length, 4)} variant="text-grid">
            {tiles}
          </ColumnLayout>
        </div>
      </SpaceBetween>
    </Container>
  );
}
